import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0E3A5D] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <div className="text-2xl font-bold mb-4">
              <span className="text-white">DVS</span>
              <span className="text-[#4FB3D9]"> Power Washing</span>
            </div>
            <p className="text-white/80 text-sm leading-relaxed">
              Professional pressure washing services in Dallas Metroplex, Texas. Quality service you can trust.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-white/80 hover:text-white transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-white/80 hover:text-white transition-colors text-sm">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-white/80 hover:text-white transition-colors text-sm">
                  About
                </Link>
              </li>
              <li>
                <Link to="/process" className="text-white/80 hover:text-white transition-colors text-sm">
                  Process
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-white/80 hover:text-white transition-colors text-sm">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4">Services</h3>
            <ul className="space-y-2 text-sm text-white/80">
              <li>
                <Link to="/services#house-washing" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  House Washing
                </Link>
              </li>
              <li>
                <Link to="/services#driveway-cleaning" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Driveway Cleaning
                </Link>
              </li>
              <li>
                <Link to="/services#roof-washing" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Roof Soft Washing
                </Link>
              </li>
              <li>
                <Link to="/services#fence-patio" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Fence &amp; Patio Cleaning
                </Link>
              </li>
              <li>
                <Link to="/services#commercial" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Commercial Pressure Washing
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4">Contact Us</h3>
            <div className="space-y-3 text-sm">
              <a
                href="tel:2146368343"
                className="flex items-center space-x-2 text-white/80 hover:text-white transition-colors"
              >
                <i className="ri-phone-fill text-[#4FB3D9]"></i>
                <span>(214) 636-8343</span>
              </a>
              <div className="flex items-start space-x-2 text-white/80">
                <i className="ri-map-pin-fill text-[#4FB3D9] mt-1"></i>
                <span>Dallas Metroplex, Texas<br />Serving Greater Dallas Area</span>
              </div>
              <a
                href="https://www.instagram.com/dvs_power_washing_dallas/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 text-white/80 hover:text-[#E1306C] transition-colors cursor-pointer"
              >
                <i className="ri-instagram-fill text-[#4FB3D9]"></i>
                <span>@dvs_power_washing_dallas</span>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-sm text-white/70">
            &copy; {currentYear} DVS Power Washing. All rights reserved.
          </p>
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-white/70 hover:text-white transition-colors"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
